var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ModulatorBoxAdapter_box;
import { ModulationBox } from "@opendaw/studio-boxes";
import { asInstanceOf, isInstanceOf, Terminator, ValueMapping } from "@opendaw/lib-std";
import { ParameterAdapterSet } from "../ParameterAdapterSet";
import { FieldParameterTracks } from "../timeline/ParameterTracks";
import { ModulationBoxAdapter } from "./ModulationBoxAdapter";
const percent = (value) => (value * 100.0).toFixed(0);
export const rangeStringMapping = (bipolar) => ({
    x: (value) => ({ value: `${bipolar.getValue() ? "±" : "+"}${percent(value)}`, unit: "%" }),
    y: (text) => {
        const value = parseFloat(text.replace("±", "").replace("+", "").trim());
        return isNaN(value) ? { type: "unknown", value: text.trim() } : { type: "explicit", value: value / 100.0 };
    }
});
export const polarityStringMapping = (bipolar) => ({
    x: (value) => ({ value: percent(bipolar.getValue() ? value * 2.0 - 1.0 : value), unit: "%" }),
    y: (text) => {
        const value = parseFloat(text.replace("%", "").trim());
        if (isNaN(value)) {
            return { type: "unknown", value: text.trim() };
        }
        return { type: "explicit", value: bipolar.getValue() ? value / 200.0 + 0.5 : value / 100.0 };
    }
});
export const isModulatorBox = (box) => box.tags.type === "modulator";
export class ModulatorBoxAdapter {
    constructor(context, box) {
        this.terminator = new Terminator();
        _ModulatorBoxAdapter_box.set(this, void 0);
        this.context = context;
        __classPrivateFieldSet(this, _ModulatorBoxAdapter_box, box, "f");
        this.parametric = this.terminator.own(new ParameterAdapterSet(context));
        this.tracks = this.terminator.own(new FieldParameterTracks(box.graph, box.tracks, context.boxAdapters));
        this.amount = this.parametric.createParameter(box.amount, ValueMapping.unipolar(), rangeStringMapping(box.bipolar), "Range");
    }
    get box() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").address; }
    get label() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").label.getValue(); }
    get labelField() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").label; }
    get enabled() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").enabled.getValue(); }
    get indexField() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").index; }
    get bipolarField() { return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").bipolar; }
    get assignments() {
        return __classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").assignments.pointerHub.incoming()
            .map(({ box }) => this.context.boxAdapters.adapterFor(asInstanceOf(box, ModulationBox), ModulationBoxAdapter));
    }
    /// The subclass creates its parameters, then hands them their lane owner: automation of a modulator's
    /// parameter lives on the modulator, not on an audio unit.
    registerParameterTracks() {
        const parameters = this.parametric.parameters();
        parameters.forEach(parameter => this.terminator.own(parameter.registerTracks(this.tracks)));
        this.terminator.own(__classPrivateFieldGet(this, _ModulatorBoxAdapter_box, "f").bipolar.subscribe(() => parameters.forEach(parameter => parameter.notifyPrinting())));
    }
    terminate() { this.terminator.terminate(); }
}
_ModulatorBoxAdapter_box = new WeakMap();
export const isModulatorBoxAdapter = (adapter) => isInstanceOf(adapter, ModulatorBoxAdapter);
